import './Intro.css'
import imgIntro from '../../assets/images/house-banner.png'
import Img from '../../component/Img'

const Intro = () => {

  return (
    <>
      <div className="intro container" id='intro'>
        <div className="intro-l">
          <div className="company-name" data-aos="slide-right" data-aos-duration='1000'>Homi</div>
          <div className="company-purpose" data-aos="slide-right" data-aos-duration='1000' data-aos-delay='750'>Find Your Dream House By Us</div>
          <div className="company-content" data-aos="slide-right" data-aos-duration='1000' data-aos-delay='1500'>Powerful ,self-serve product and growth analytics to help you convert , engage and retain more</div>
        </div>
        <div className="intro-r">
          <Img src={imgIntro} alt="intro" />
        </div>
      </div>
    </>
  )
}

export default Intro